export var Network;
(function (Network) {
    Network[Network["Mainnet"] = 0] = "Mainnet";
    Network[Network["Testnet"] = 1] = "Testnet";
})(Network || (Network = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibmV0d29yay5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jYXJkYW5vL2VudGl0aWVzL25ldHdvcmsudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxDQUFOLElBQVksT0FHWDtBQUhELFdBQVksT0FBTztJQUNqQiwyQ0FBTyxDQUFBO0lBQ1AsMkNBQU8sQ0FBQTtBQUNULENBQUMsRUFIVyxPQUFPLEtBQVAsT0FBTyxRQUdsQiJ9